<template>
   <b-container>
      <PageTitle title="Questionnaires" />
      <QuestionnaireReviewForm />
   </b-container>
</template>

<script>
import QuestionnaireReviewForm from './widgets/QuestionnaireReviewForm.vue';
import {mapGetters} from 'vuex';

export default {
   components: {
      QuestionnaireReviewForm,
   },

   computed: {
      ...mapGetters({
         activeStudyId: 'companies/activeStudyId',
         hasQuestionnaireAssignment: 'progress/hasQuestionnaireAssignment',
      }),

      companyId() {
         return this.$route.params.id;
      },

      questionnaireId() {
         return this.$route.params.questionnaireId;
      },
   },

   methods: {
      /** Load the company questionnaire data */
      async fetchData() {
         await this.loadPage([
            this.$store.dispatch('questionnaire/loadCompanyQuestionnaire', {
               questionnaireId: this.questionnaireId,
            }),
            this.$store.dispatch('questionnaire/loadQuestionnaires', {companyId: this.companyId}),
         ]);
      },
   },

   async created() {
      await this.fetchData();
   },

   watch: {
      async activeStudyId() {
         if (this.isActiveStudyInSetupStage) {
            this.$router.push({name: 'Home'});
            return;
         }
         if (!this.hasQuestionnaireAssignment) {
            this.$router.push({name: 'Home'});
         } else {
            await this.fetchData();
         }
      },
   },
};
</script>
